import { render, staticRenderFns } from "./order-list-page.vue?vue&type=template&id=7ca05798&"
import script from "./order-list-page.vue?vue&type=script&lang=js&"
export * from "./order-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports